import { supportThreadStatus, type SupportThread, type SupportTone } from '../../lib/supportApi';

const TONE: Record<SupportTone, { bg: string; color: string }> = {
  waiting: { bg: '#fef3c7', color: '#92400e' },
  replied: { bg: '#dbeafe', color: '#1e40af' },
  closed: { bg: '#f3f4f6', color: '#374151' },
};

export function SupportStatusPill({
  thread,
}: {
  thread: Pick<SupportThread, 'status' | 'last_author'>;
}): JSX.Element {
  const view = supportThreadStatus(thread);
  const tone = TONE[view.tone];
  return (
    <span
      data-testid="support-status"
      data-tone={view.tone}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '0.1875rem 0.625rem',
        borderRadius: '9999px',
        fontSize: '0.75rem',
        fontWeight: 700,
        whiteSpace: 'nowrap',
        background: tone.bg,
        color: tone.color,
      }}
    >
      {view.label}
    </span>
  );
}
